import { render, staticRenderFns } from "./OsDesktopTable.vue?vue&type=template&id=8e46a714&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./OsDesktopTable.vue?vue&type=script&lang=js&"
export * from "./OsDesktopTable.vue?vue&type=script&lang=js&"
import style0 from "./OsDesktopTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports